<template>
<!--  客户基础信息展示-->
  <div>
    <a-skeleton active :loading="loading" :title="false" :paragraph="{rows:4}">
    <div class="custoer_base_div">
      <div class="top_div">
        <div>
          <div class="short_name">{{customerVO.companySortNameCn}}</div>
          <div>
            {{$t('customer.fullName')}}:
            <span>{{customerVO.companyName}}</span>
          </div>
        </div>
        <div @click="startEdit" v-if="showEdit">
          <pt-icon  :style-obj="styleObj" type="icon-bianji1" class="edit_icon"></pt-icon>
        </div>
      </div>
      <div class="tags_div">
        <div >{{customerVO.customerTypeStr}}</div>
        <div v-if="customerVO.tradeName != '~'">{{customerVO.tradeName}}</div>
        <div v-if="customerVO.natureOfCompanyStr != '~'">{{customerVO.natureOfCompanyStr}}</div>
        <div v-if="customerVO.source != '0'">{{$t('customer.customerList.goldPlan')}}</div>
        <slot></slot>
      </div>
    </div>
    </a-skeleton>
  </div>

</template>

<script>
import Api from '@/api/mine/customer'
export default {
  name: 'customerBase',
  props:{
    customerId:{
      type:String,
      default:null,
    },
    styleObj:{
      type:String,
      default:null,
    },
    showEdit:{
      type:Boolean,
      default:true,
    },
    otherTag:{
      type:Array,
      default:()=>{return []}
    }
  },
  data(){
    return {
      customerVO:{

      },
      loading:false,
    }
  },
  watch:{
    customerId(){
      this.initCompanyInfo();
    }
  },
  mounted() {
    this.initCompanyInfo();
  },
  methods:{
    initCompanyInfo(){

      if(this.customerId){
        this.loading = true;
        Api.selectOne(this.customerId).then(res=>{
          this.loading = false;
          if(res.code == 1){
            this.customerVO = res.data

          }
        })
      }
    },
    startEdit(){
      this.$emit("startEdit")
    }
  }
}
</script>

<style scoped lang="less">
  .custoer_base_div{
    min-height: 100px;
    background: #fafbfc;
    margin-bottom: 30px;
    padding: 20px 11px 20px 32px;
    .top_div{
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      color: #999999;
      letter-spacing: 0;
      font-weight: 600;
      margin-bottom: 15px;
      >div{
        display: flex;
        align-items: center;
      }
      .edit_icon{
        font-size: 18px;
      }
      .short_name{
        font-size: 18px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 600;
        margin-right: 30px;
      }
    }
    .tags_div{
      display: flex;
      >div{
        background: #EDEDED;
        border-radius: 2px;
        font-size: 12px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 600;
        margin-right: 15px;
        padding: 2px 5px;
        min-width: 45px;
        text-align: center;
      }
    }
  }
</style>